// Sentry によるクライアントエラーの収集とトレーシング。収集が有効かどうかはレイアウトが
// DSN を meta タグへ出力しているかで決まり、無効なページでは SDK を初期化しないため
// 外部送信は発生しない。画像・入力文字列・ファイル名は送らない（端末内処理の約束を収集でも
// 守る）ため、throw するエラーのメッセージには固定文言だけを使い、ユーザーデータを含めないこと。

import type { BrowserOptions } from "@sentry/browser";

export function readDsn(doc: Pick<Document, "querySelector">): string | null {
  return doc.querySelector('meta[name="sentry-dsn"]')?.getAttribute("content") ?? null;
}

export function buildInitOptions(dsn: string): BrowserOptions {
  return {
    dsn,
    // 既定値と同じだが、端末内処理の約束（IP 等の PII をイベントに付与しない）を
    // 設定として固定する
    sendDefaultPii: false,
    // 分散トレーシング（ADR GOKKO-LIVE-13）。pageload はレイアウトの sentry-trace meta
    // からサーバー側のサンプリング決定を引き継ぐため、この率はブラウザ起点のトレースにのみ効く
    tracesSampleRate: 0.1,
  };
}
